import React from 'react';
import styled from 'styled-components';

import { DollarSign } from './styled';
import theme from './styled/theme';

const PriceWrapper = styled.h3`
  color: ${props => props.textColor || props.color || theme.colors.grayDark};
  font-size: 40px;
  font-weight: ${props => props.fontWeight || '900'};
  margin: ${props =>
    props.inline ? props.margin || '0 0 0 0.35rem' : props.margin || '0 1rem 0 0'};
  position: ${props => (props.inline ? 'static' : props.position || 'absolute')};
  text-transform: uppercase;
  transform: ${props => (props.inline ? 'none' : props.transform || 'translateX(-120%)')};
  display: ${props => (props.inline ? 'inline-flex' : 'block')};
  align-items: center;
  cursor: ${props => (props.clickable ? 'pointer' : 'inherit')};
  user-select: ${props => (props.clickable ? 'none' : 'auto')};

  span,
  .dollar {
    font-size: 20px;
    text-transform: none;
  }

  @media (max-width: 767px) {
    font-size: 30px;
    margin: ${props =>
      props.inline ? props.margin || '0 0 0 0.25rem' : props.margin || '0 0.5rem 0 0'};

    span,
    .dollar {
      font-size: 16px;
    }
  }
`;

const PriceTag = ({
  price,
  color,
  textColor,
  fontWeight,
  position,
  transform,
  margin,
  className,
  inline,
  clickable,
  onClick,
}) => {
  const handleKeyDown = event => {
    if (!onClick) return;
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      onClick(event);
    }
  };

  return price ? (
    <PriceWrapper
      className={className}
      color={color}
      textColor={textColor}
      fontWeight={fontWeight}
      position={position}
      transform={transform}
      margin={margin}
      inline={inline}
      clickable={clickable}
      onClick={onClick}
      onKeyDown={handleKeyDown}
      role={clickable ? 'button' : undefined}
      tabIndex={clickable ? 0 : undefined}
    >
      <span>rd</span>
      <DollarSign>$</DollarSign>
      {price}
    </PriceWrapper>
  ) : null;
};

export default PriceTag;
